import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Lenspire_Icon_VideoPlay",
  "use": "Lenspire_Icon_VideoPlay-usage",
  "viewBox": "0 0 60 60",
  "content": "<symbol viewBox=\"0 0 60 60\" id=\"Lenspire_Icon_VideoPlay\">\n<path d=\"M30,0C13.431,0,0,13.431,0,30s13.431,30,30,30s30-13.431,30-30S46.569,0,30,0z M24,39V21l16,9L24,39z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./frontend/assets/icons/Lenspire_Icon_VideoPlay.svg
// module id = 754
// module chunks = 0